/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetOfferPaymentMethods403Response { 
    error_key?: GetOfferPaymentMethods403Response.ErrorKeyEnum;
}
export namespace GetOfferPaymentMethods403Response {
    export type ErrorKeyEnum = 'promocode.prohibited';
    export const ErrorKeyEnum = {
        PromocodeProhibited: 'promocode.prohibited' as ErrorKeyEnum
    };
}


